import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sqg-linkUserToFolders" }
const _hoisted_2 = { class: "sqg-linkUserToFolders__content" }
const _hoisted_3 = {
  key: 1,
  class: "sqg-linkUserToFolders__folders"
}
const _hoisted_4 = { class: "sqg-linkUserToFolders__line" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Lier les dossiers")

import {onMounted, ref} from "vue";
import {useUserStore} from "@/stores/user";
import {useFoldersStore} from "@/stores/folders";
import {AxiosResponse} from "axios";
import Modale from '@/modales/Modale.vue';
import Checkbox from '@/components/Checkbox.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import {arrayToggleBaseOnId} from '@/functions/utils';
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  props: {
  user: { type: Object, default: {} },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props





//STORE user
const userStore = useUserStore();
const { user } = storeToRefs(userStore);
//STORE folder
const foldersStore = useFoldersStore();

//DATA
const availableFolders = ref([]);
const currentFolders = ref([]);
const loader = ref(false);

const loadFolders = () => {
  foldersStore.getFoldersByUserId(props.user.id).then((response: AxiosResponse) => currentFolders.value = response.data).then(()=> {
    if (isAdmin.value) {
      foldersStore.getFoldersByUserId(props.user.responsableId).then((response: AxiosResponse) => {
        availableFolders.value = response.data;
        loader.value = false;
      })
    } else {
      foldersStore.getFolders().then((response: AxiosResponse) => {
        availableFolders.value = response.data;
        loader.value = false;
      })
    }
  });
}

const setFolders = () => {
  loader.value = true;
  userStore.setFoldersByUser(props.user.id, currentFolders.value.map((folder: any) => folder.id)).then(() => {
    emit('close');
  });
};

const isAdmin = ref(false);

onMounted(() => {
  if (user.value.role === 'admin' || user.value.role === 'superAdmin') isAdmin.value = true;
  loadFolders();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Modale, {
      width: "40",
      height: "80",
      title: "Ajouter des dossiers à l'utilisateur",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (loader.value)
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableFolders.value, (folder, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "sqg-linkUserToFolders__folder"
                  }, [
                    _createVNode(Checkbox, {
                      checked: currentFolders.value.find((currentFolder) => currentFolder.id === folder.id) !== undefined,
                      onOnChange: ($event: any) => (_unref(arrayToggleBaseOnId)(currentFolders.value, folder))
                    }, null, 8, ["checked", "onOnChange"]),
                    _createTextVNode(_toDisplayString(folder.name), 1)
                  ]))
                }), 128))
              ])),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Button, { onClick: setFolders }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})